import { useEffect, useState } from "react";

const useMergedLegend = (gisData) => {
  const [mergedLegends, setMergedLegends] = useState([]);

  useEffect(() => {
    if (gisData && gisData?.type !== "FeatureCollection") {
      // This will be an array to hold each item's legendAttributes
      const legendsArray = [];

      gisData?.forEach((item) => {
        if (item?.withLegend) {
          // Instead of merging, we simply push the legendAttributes object into the array
          legendsArray.push(...(item.legendAttributes || []));
        }
      });

      // Only update the state if legendsArray is not empty.
      if (legendsArray.length > 0) {
        setMergedLegends(legendsArray);
      } else {
        setMergedLegends([]);
      }
    }
  }, [gisData]); // Re-run the hook if gisData changes

  return mergedLegends;
};

export default useMergedLegend;
